import axios from './axios';
import { API_URL } from '@moxie/constants';
import { IAuthCompany, IAuthResponse } from '@shared-components/models';

const updateCompany = (body: IAuthCompany): Promise<IAuthResponse> => {
  return axios.put(API_URL.COMPANY_CRM, body);
};

export { updateCompany };
